import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { renderToString } from 'react-dom/server';
import { animated, Spring } from 'react-spring';

import SharingPopup from 'components/SharingPopup';
import TrainingText from 'components/TrainingContent/TrainingText';
import TrainingVideo from 'components/TrainingContent/TrainingVideo';

export default class RetainContent extends Component {
  constructor(props) {
    super(props);

    const { image } = this.props;

    this.state = {
      image,
      showContent: false,
      index: 0,
    };

    this.toggleContent = this.toggleContent.bind(this);
  }

  componentDidUpdate() {
    const { image } = this.state;
    const { image: propImage } = this.props;
    if (image !== propImage) {
      this.updateContent(propImage);
    }
  }

  updateContent(image) {
    this.setState({ image });
    this.setState({ showContent: false });
  }

  toggleContent() {
    this.setState((prevState) => ({
      showContent: !prevState.showContent,
    }));
    this.setState(({ index }) => ({ index: index === 2 ? 0 : index + 1 }));
  }

  render() {
    const { image, showContent, index } = this.state;

    const { appId, params, buttons } = this.props;

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: 'x',
      },
      baseClass: 'customBox',
      buttons: ['share', 'close'],
      share: {
        tpl: renderToString(<SharingPopup url={image} />),
      },
    };

    return (
      <div className="retain__container">
        {params.pageType !== 'Photo' && params.pageType !== 'autoPlay' && (
          <React.Fragment>
            <div className="image__container">
              <img
                data-fancybox={`trainingImage_${image}`}
                data-options={JSON.stringify(fancyOptions)}
                data-caption={params.imageCredits}
                href={image}
                src={image}
                alt={image.toString()}
              />
              {params.imageCredits && <h3 className="imageCredits">{params.imageCredits}</h3>}
            </div>
            <Spring
              native
              keys={index}
              to={{
                opacity: showContent ? 1 : 1,
                top: showContent ? 100 : 100,
                display: 'block',
              }}
            >
              {(styles) => (
                <animated.div className="retain__text" style={styles}>
                  {buttons}

                  <TrainingText
                    key={index}
                    pageID={params.pageID}
                    buttons={null}
                    appId={appId}
                    {...params}
                    // hideTitle
                  />
                </animated.div>
              )}
            </Spring>
          </React.Fragment>
        )}
        {params.pageType === 'Photo' && (
          <div className="retain__photo">
            <img src={image} alt={image} />
          </div>
        )}
        {params.pageType === 'autoPlay' && (
          <div className="retain__video">
            <TrainingVideo appId={appId} {...params} />
          </div>
        )}
      </div>
    );
  }
}

RetainContent.propTypes = {
  appId: PropTypes.number.isRequired,
  buttons: PropTypes.arrayOf(PropTypes.shape()),
  summary: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.shape()]),
  }),
  image: PropTypes.string,
  params: PropTypes.shape().isRequired,
};

RetainContent.defaultProps = {
  buttons: [],
  image: PropTypes.string.isRequired,
  summary: {
    title: '',
    text: [],
  },
};
